/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

// Accordion product notice logic
let accordianHead = Array.from(document.querySelectorAll(".accordian_head"));

accordianHead.map((item) =>
  item.addEventListener("click", () => {
    closeAllAccordian(item);
  })
);

function closeAllAccordian(current_target) {
  console.log("click");
  accordianHead.map((item) => {
    if (current_target !== item) {
      const accordianBody = item.nextElementSibling;
      const togglerBtn = item.firstElementChild;
      togglerBtn.classList.remove("active");
      accordianBody.classList.remove("active_body");
    } else {
      const accordianBody = current_target.nextElementSibling;
      const togglerBtn = item.firstElementChild;
      togglerBtn.classList.toggle("active");
      accordianBody.classList.toggle("active_body");
    }
  });
}

document.addEventListener('variant:changed', function(event) {
  var variant = event.detail.variant; // Get the variant that was added
  //Update paypal instalment
  const pp_inst_container = document.querySelector("#paypal-instalment-container");
  if(!pp_inst_container){
    return;
  }
  const pp_instalment = pp_inst_container.querySelector("[data-pp-amount]");
  if(!pp_instalment){
    return;
  }
  const price = (variant.price / 100).toFixed(2)
  pp_instalment.setAttribute("data-pp-amount", price )
});
